export const getItemsCount = (mailpieces: { length: number }) =>
  mailpieces.length > 1 ? mailpieces.length : 0;

export const getRecipientName = (mailpieces: { recipient?: { displayName?: string } | null }[]) =>
  mailpieces[0]?.recipient?.displayName || 'recipient';

export const renderItemsCount = (count: number) =>
  count ? (
    <>
      {' '}
      for <strong>{count}</strong> item(s)
    </>
  ) : null;

export const isPickUpLessCurrentDate = (pickUpDate: Date) => {
  const clonePickUpDate = new Date(pickUpDate.getTime());
  const currentDate = new Date();

  clonePickUpDate.setSeconds(0, 0);
  currentDate.setSeconds(0, 0);

  return clonePickUpDate.getTime() < currentDate.getTime();
};
